import {
  Dropdown,
  Field,
  Option,
  makeStyles,
  tokens,
  OptionOnSelectData,
  Text,
} from "@fluentui/react-components";
import { UseFormReturn } from "react-hook-form";
import { ISignForm } from "../../interfaces/ISignForm";
import { ITextFieldErrorText } from "../../interfaces/ITextFieldErrorText";
import {
  availableTextWidth,
  calculateScaledDimensions,
  canSelectHeight,
  measureTextWidth,
  sizeOptions,
} from "../../helper/signGeneratorHelper";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
type SignSizeFormProps = {
  signForm: UseFormReturn<ISignForm, any, ISignForm>;
  fieldsWithErrorMessage: ITextFieldErrorText[];
  setFieldsWithErrorMessage: React.Dispatch<
    React.SetStateAction<ITextFieldErrorText[]>
  >;
};
const useStyles = makeStyles({
  flexEnd: {
    display: "flex",
    alignItems: "flex-end",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase500,
    marginTop: tokens.spacingVerticalXXL,
  },
  field: {
    width: "100%",
    fontWeight: tokens.fontWeightBold,
    marginTop: tokens.spacingVerticalXXL,
  },
  widthHundred: {
    width: "100%",
  },
  radio: {
    marginRight: tokens.spacingVerticalL,
    height: "35px",
    width: "35px",
  },
  widthInputMargin: {
    marginRight: "52px",
  },

  inputHeight: {
    height: tokens.spacingVerticalXXXL,
  },
  zIndex: {
    zIndex: 1,
  },
});
export const SignSizeForm = ({
  signForm,
  fieldsWithErrorMessage,
  setFieldsWithErrorMessage,
}: SignSizeFormProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  // const [sizeType, setSizeType] = useState<"templateSize" | "customSize">(
  //   "customSize"
  // );
  const { setValue, watch, getValues } = signForm;
  const { height, width, symbol } = watch();
  const templates = sizeOptions();
  const onOptionTemplateSelect = (option: OptionOnSelectData) => {
    const selectedOption = templates.find((x) => x.key === option.optionValue);

    if (fieldsWithErrorMessage?.length > 0) {
      const prevWidth = watch("width");
      if (selectedOption.width > prevWidth) {
        setFieldsWithErrorMessage([]);
      }
    }

    if (selectedOption) {
      setValue("width", selectedOption.width);
      setValue("height", selectedOption.height);
    }
  };

  const menuOptionIsDisabled = (sizeOption: any) => {
    const {
      scaleFactor,
      width: scaledWidth,
      height: scaledHeight,
    } = calculateScaledDimensions(
      sizeOption.width,
      sizeOption.height,
      window.innerWidth < 1700 ? 500 : 800
    );

    const texts = watch("texts") || [];
    if (texts.length > 0) {
      let longestTextItem = texts[0];
      for (const item of texts) {
        if ((item.text?.length || 0) > (longestTextItem.text?.length || 0)) {
          longestTextItem = item;
        }
      }
      const longestText = longestTextItem;

      return (
        measureTextWidth(
          longestText?.text,
          (longestText?.fontSize * scaleFactor) / 0.8,
          scaledWidth
        ) >
          availableTextWidth(
            sizeOption.width,
            scaledWidth,
            scaleFactor,
            symbol
          ) ||
        !canSelectHeight(
          sizeOption.height,
          scaledHeight,
          scaleFactor,
          getValues
        )
      );
    }
    return false;
  };

  return (
    <>
      <div className={styles.flexEnd}>
        {/* <Radio
          value="templateSize"
          className={styles.radio}
          checked={sizeType === "templateSize"}
          onChange={() => setSizeType("templateSize")}
        /> */}
        <Field
          label={t("label.proposedSize")}
          className={styles.field}
          size="medium"
        >
          <Dropdown
            style={{ minWidth: "auto", width: "100%" }}
            value={
              templates
                .find((x) => x.height === height && x.width === width)
                ?.key.toString() || ""
            }
            className={styles.inputHeight}
            onOptionSelect={(e, option) => {
              onOptionTemplateSelect(option);
            }}
            //disabled={sizeType !== "templateSize"}
          >
            {templates.map((x) => (
              <div>
                <Option
                  key={x.key}
                  id={`tooltip-signsize-${x.key}`}
                  value={x.key.toString()}
                  disabled={menuOptionIsDisabled(x)}
                >
                  {x.text}
                </Option>
                {menuOptionIsDisabled(x) && (
                  <Tooltip
                    anchorSelect={`#tooltip-signsize-${x.key}`}
                    className={styles.zIndex}
                  >
                    <div className={styles.flexColumn}>
                      <Text as="p">{t("tooltip.signSize")}</Text>
                      <Text as="p">{t("tooltip.signSizePt2")}</Text>
                    </div>
                  </Tooltip>
                )}
              </div>
            ))}
          </Dropdown>
        </Field>
      </div>
      {/* <div className={styles.flexEnd}>
        <Radio
          value="customSize"
          className={styles.radio}
          checked={sizeType === "customSize"}
          onChange={() => setSizeType("customSize")}
        />
        <Controller
          name={"width"}
          control={control}
          rules={{ required: true }}
          render={({ field: { value, onChange } }) => (
            <Field
              label={t("label.widthMillimeters")}
              className={mergeClasses(
                styles.widthHundred,
                styles.widthInputMargin,
                styles.label
              )}
              size="medium"
            >
              <Input
                type="number"
                className={styles.inputHeight}
                value={String(value)}
                onChange={(e, value) => {
                  onChange(parseInt(value.value));
                }}
                disabled={sizeType !== "customSize"}
              />
            </Field>
          )}
        />
        <Controller
          name={"height"}
          control={control}
          rules={{ required: true }}
          render={({ field: { value, onChange } }) => (
            <Field
              label={t("label.heightMillimeters")}
              className={styles.field}
              size="medium"
            >
              <Input
                type="number"
                className={styles.inputHeight}
                value={String(value)}
                onChange={(e, value) => {
                  onChange(parseInt(value.value));
                }}
                disabled={sizeType !== "customSize"}
              />
            </Field>
          )}
        />
      </div> */}
    </>
  );
};
